import { createContext, useContext, useState, useCallback } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // Persist api_key across page refreshes with sessionStorage
  const [apiKey, setApiKey] = useState(() => sessionStorage.getItem("dm_api_key") || null);
  const [user,   setUser]   = useState(() => {
    try { return JSON.parse(sessionStorage.getItem("dm_user") || "null"); } catch { return null; }
  });

  const login = useCallback((key, userInfo) => {
    sessionStorage.setItem("dm_api_key", key);
    sessionStorage.setItem("dm_user", JSON.stringify(userInfo));
    setApiKey(key);
    setUser(userInfo);
  }, []);

  const logout = useCallback(() => {
    sessionStorage.removeItem("dm_api_key");
    sessionStorage.removeItem("dm_user");
    setApiKey(null);
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ apiKey, user, login, logout, isAuthenticated: !!apiKey }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside <AuthProvider>");
  return ctx;
}